<script setup lang="ts">
import PdsIcon from '@/components/pds/PdsIcon.vue';
import type { PdsIconName } from '@/components/pds/icons';

// Un vide dit ce qui va s'y passer, il ne laisse pas un panneau nu.
defineProps<{ icon: PdsIconName; title: string; text: string }>();
</script>

<template>
  <div
    class="flex flex-col items-center justify-center gap-[10px] px-4 pt-[26px] pb-6 text-center"
  >
    <span
      class="bg-creux text-encre-douce mb-[2px] flex size-[76px] items-center justify-center rounded-full"
    >
      <PdsIcon :name="icon" :size="36" />
    </span>
    <p class="text-[16px] leading-[22px] font-semibold">{{ title }}</p>
    <p class="text-encre-douce max-w-[30ch] text-[14px] leading-[20px]">
      {{ text }}
    </p>
  </div>
</template>
